export default {
  methods: {

    /**
     *  Retourne déconseillé aux moins de {age} ans en fonction du csa
     *  Si csa = 1 alors ne retourne rien
     * @param csa
     * @returns {string}
     */
    csaLabel (csa) {
      const csaMapper = {
        2: '10',
        3: '12',
        4: '16',
        5: '18'
      }
      return csaMapper[csa] ? `déconseillé aux moins de ${csaMapper[csa]} ans` : ''
    }
  }
}
